var React = require('react');

function IcDate (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 19q-.225 0-.363-.137-.137-.138-.137-.363v-8.15l-1.975 1.975q-.125.125-.337.137-.213.013-.363-.137-.175-.175-.175-.363 0-.187.175-.362l2.6-2.6q.15-.15.288-.2.137-.05.287-.05.15 0 .288.05.137.05.287.2l2.6 2.6q.15.15.163.35.012.2-.163.375-.15.15-.35.15-.2 0-.35-.15L12.5 10.35v8.15q0 .225-.137.363Q12.225 19 12 19ZM5.5 8.65q-.225 0-.362-.138Q5 8.375 5 8.15V6.275q0-.7.463-1.163.462-.462 1.162-.462h10.75q.7 0 1.163.462.462.463.462 1.163V8.15q0 .225-.137.362-.138.138-.363.138-.225 0-.362-.138Q18 8.375 18 8.15V6.275q0-.225-.188-.425-.187-.2-.437-.2H6.625q-.25 0-.437.2Q6 6.05 6 6.275V8.15q0 .225-.137.362-.138.138-.363.138Z"}));
}

IcDate.defaultProps = {"height":"24","width":"24"};

module.exports = IcDate;

IcDate.default = IcDate;
